import { render, staticRenderFns } from "./SpecimenDetails.vue?vue&type=template&id=5917ee89"
import script from "./SpecimenDetails.vue?vue&type=script&lang=js"
export * from "./SpecimenDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecimenDetails.vue?vue&type=style&index=0&id=5917ee89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports